import React, { useState } from "react";
import ShareButton from "../AllProducts/ShareButton";
import parse from "html-react-parser";

const BlogCategoriesCard = ({ data }) => {
  const [current, setCurrent] = useState(false);

	const handleOnClick = () => {
		setCurrent((prev) => !prev);
	};

  

  return (
    <div className="group bg-white border-2 rounded-2xl shadow-lg hover:border-blue-800 transition-all duration-300 overflow-hidden">
      <div className="flex flex-col md:flex-row">
        <div className="md:w-1/3 w-full h-[200px] bg-gray-100 flex items-center justify-center">
          <img
            src={`${process.env.REACT_APP_SERVER}/media/images/blog/${data.image}`}
            alt={data.title}
            className="object-contain h-full w-full rounded-t-2xl md:rounded-l-2xl md:rounded-t-none"
          />
        </div>
        <div className="md:w-2/3 w-full p-4 flex flex-col justify-between relative">
          <div>
            <div className="flex justify-between items-start">
              <h2 className="text-blue-900 font-semibold text-lg md:text-xl line-clamp-2">
                {data.title}
              </h2>
              <div className="flex flex-col items-center space-y-2 ml-2">
                <svg
                  onClick={(e) => {
                    e.stopPropagation();
                   handleOnClick();
                  }}
                  className="cursor-pointer"
                  width={25}
                  height={25}
                  viewBox="0 0 25 25"
                  fill={current ? "red" : "none"}
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.38 1.34c-1.34-.02-2.73.41-3.8 1.63-1.08-1.21-2.48-1.63-3.78-1.63-3.19 0-6.38 2.91-6.38 7.03 0 3.98 2.31 7.3 4.62 9.56 1.02 1 2.14 1.9 3.3 2.67.47.3.91.54 1.27.7.22.09.45.17.65.17.21 0 .43-.08.65-.17.36-.16.8-.4 1.27-.7 1.16-.77 2.28-1.67 3.3-2.67 2.31-2.26 4.62-5.58 4.62-9.56 0-4.13-3.17-6.99-6.39-7.03z"
                    stroke={current ? "red" : "#004B95"}
                    strokeWidth={1.5}
                  />
                </svg>
                <div onClick={(e) => e.stopPropagation()}>
                  <ShareButton
                    title={data.title}
                    image={`${process.env.REACT_APP_SERVER}/media/images/blog/${data.image}`}
                  />
                </div>
              </div>
            </div>
            <p className="text-sm text-blue-900 mt-3 line-clamp-4">
              {parse(
                data.description.replace(/<h1/g, "<p").replace(/h1>/g, "p>")
              )}
            </p>
          </div>

          <div className="flex justify-between items-center mt-4 text-gray-600 text-sm">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-white rounded-full p-1 shadow-md">
                <img
                  src="/static/images/icon.png"
                  alt="Author"
                  className="w-full h-full object-cover rounded-full"
                />
              </div>
              <div>
                <p className="text-sm font-medium text-blue-900">
                  {data.author}
                </p>
                <p className="text-xs text-gray-500">
                  {data.date}
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-1">
              <i className="fa-solid fa-eye"></i>
              <span>{data.views}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogCategoriesCard;

